<template>

     <div  @keyup.enter="doSearch">

                <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                        <template slot="header">
                            <span> Search  </span>
                        </template>
                        <nav class="level">
                            <div class="level-left">
                                <b-input   v-model="searchTxt" :placeholder=placeholderTxt
                                ></b-input>
                                &nbsp;
                                <b-button type="is-success" icon-left="magnify"  outlined      ref="btnSearch" @click="doSearch" ></b-button>
                                &nbsp;
                                <b-button type="is-success" icon-left="close"  outlined   ref="btnClearAll"  ></b-button>
                            </div>
                        </nav>

                        <b-table
                                :data="isEmpty ? [] : dataResultSearch"
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards
                                :loading="isDataResultSearchLoading"
                                paginated
                                :per-page="perPage"
                                :current-page.sync="currentPage">


                                <b-table-column   label="No"  v-slot="props">
                                    {{ props.row.idx }}
                                </b-table-column>
                                <b-table-column   label="ID"  v-slot="props">
                                    {{ props.row.id }}
                                </b-table-column>
                                <b-table-column   label="Descp."  v-slot="props" >
                                    {{ props.row.descp }}
                                </b-table-column>
                                <b-table-column   label="Unit"  v-slot="props">
                                    {{ props.row.unit }}
                                </b-table-column>
                                <b-table-column   label="#"  v-slot="props">
                                    <b-button type="is-info" @click="addItemToDetail(props.row.id,props.row.descp, props.row.unit )">Select</b-button>

                                </b-table-column>



                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                            </template>
                        </b-table>
     </div>

</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios";
    import {getBaseURLforBackEnd,getConfigAxios}  from '@/utils.js'
    import { mapState } from "vuex";

    export default {
        name: "ListParts",
        computed:{
               ...mapState({
                        access_token: state => state.master_data.access_token,
                })
        },
        methods:{

            addItemToDetail(idpart,descp,unit){
                const tmp = {
                    "idpart":idpart ,
                    "descp":descp ,
                    "unit":unit
                }
                this.$emit('addItemToDetail',tmp)
                // console.log('emit addItemToDetail')
            },
            doSearch(){
                // console.log('do search')
                // this.$buefy.toast.open('do search')
                if(this.searchTxt.length>3){

                        const datTo = {
                            "search_txt": this.searchTxt
                        }
                        const vm = this
                        this.isDataResultSearchLoading = true
                        axios.defaults.headers.common['Authorization'] = `Bearer ${ this.access_token}`  
                        axios.post(`${getBaseURLforBackEnd()}/api/searchpart`, datTo, getConfigAxios())
                            .then((res) => {
                                vm.dataResultSearch = res.data
                                vm.isDataResultSearchLoading = false
                            })
                            .finally(() => {
                                vm.isDataResultSearchLoading = false
                            })

                }else{
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Charater to search must more than 3 char',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }


            }
        },
        props:{
            placeholderTxt : String
        },
        data(){
            return {
                isFullScreenSearching : false,
                selected : [],
                searchTxt : "",
                isEmpty : false,
                dataResultSearch:[],
                isDataResultSearchLoading : false,
                perPage : 10,
                currentPage : 1,
                // placeholaderTxt : "» » บริการตรวจ Cyto ,  « « "
            }
        }
    }
</script>

<style scoped>

</style>